const country = {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AS: "Samoa thuộc Mỹ",
    AD: "Andorra",
    AO: "Angola",
    AG: "Antigua và Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AU: "Úc",
    AT: "Áo",
    AZ: "Azerbaijan",
    BS: "Bahama",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Bỉ",
    BZ: "Belize",
    BJ: "Bénin",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia và Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    BN: "Brunei",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Campuchia",
    CM: "Cameron",
    CA: "Canada",
    CV: "Cape Verde",
    CF: "Cộng hòa Trung Phi",
    TD: "Chad",
    CL: "Chilê",
    CN: "Trung Quốc",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo (Brazzaville)",
    CD: "Congo (DRC)",
    CR: "Costa Rica",
    CI: "Côte d'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Síp",
    CZ: "Cộng hòa Séc",
    DK: "Đan Mạch",
    DJ: "Djibouti",
    DM: "Dominic",
    DO: "Cộng hòa Dominica",
    EC: "Ecuador",
    EG: "Ai Cập",
    SV: "El Salvador",
    GQ: "Guinea Xích đạo",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FJ: "Fiji",
    FI: "Phần Lan",
    FR: "Pháp",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Đức",
    GH: "Ghana",
    GR: "Hy Lạp",
    GD: "Grenada",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HN: "Honduras",
    HU: "Hungary",
    IS: "Iceland",
    IN: "Ấn Độ",
    ID: "Indonesia",
    IR: "Iran",
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Ý",
    JM: "Jamaica",
    JP: "Nhật Bản",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "Bắc Triều Tiên",
    KR: "Hàn Quốc",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lào",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Litva",
    LU: "Luxembourg",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Quần đảo Marshall",
    MR: "Mauritania",
    MU: "Mauritius",
    MX: "Mexico",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mông Cổ",
    ME: "Núi Đen",
    MA: "Ma-rốc",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Hà Lan",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NO: "Na Uy",
    OM: "Ô-man",
    PK: "Pakistan",
    PW: "Palau",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PL: "Ba Lan",
    PT: "Bồ Đào Nha",
    QA: "Qatar",
    RO: "Romania",
    RU: "Nga",
    RW: "Rwanda",
    KN: "Saint Kitts và Nevis",
    LC: "Thánh Lucia",
    VC: "Saint Vincent và Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome và Principe",
    SA: "Ả Rập Saudi",
    SN: "Sénégal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapo",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Quần đảo Solomon",
    SO: "Somalia",
    ZA: "Nam Phi",
    ES: "Tây Ban Nha",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SZ: "Swaziland",
    SE: "Thụy Điển",
    CH: "Thụy Sĩ",
    SY: "Syria",
    TW: "Đài Loan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thái Lan",
    TL: "Đông Timor",
    TG: "Togo",
    TO: "Tonga",
    TT: "Trinidad và Tobago",
    TN: "Tunisia",
    TR: "Thổ Nhĩ Kỳ",
    TM: "Turkmenistan",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraina",
    AE: "UAE",
    GB: "Vương quốc Anh",
    US: "Hoa Kỳ",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Việt Nam",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    FM: "Fiji"
  };
  
  export default country;
  